<agreement-modal>
  <div
    id="{ props.modalId }"
    class="modal js-modal"
    is="modal-base"
    is-open="{ state.isOpen }"
  >
    <div class="modal__bg"></div>
    <div class="modal__content">
      <div class="modal__content_inner">
        <h2 class="heading-01 heading_search">利用規約</h2>
        <div style="max-height:300px;overflow-y: scroll">
        <rules-content-tag></rules-content-tag>
        </div>
        <div class="checkbox_wrap">
          <input
            type="checkbox"
            name="rule"
            id="rule"
            class="checkbox-input js-check"
            checked="{ state.isAgreed }"
            onclick="{ e=> onCheck(e) }"
          />
          <label for="rule" class="checkbox-parts">
            利用規約に同意する
          </label>
        </div>
        <div class="container_button">
          <button id="button" class="button button-primary button-primary-mini" type="button" value="登録する" onclick={props.agree} disabled="{ !state.isAgreed }">登録する</button>
        </div><!--/.container_button-->
      </div><!--/.modal__content_inner-->
    </div><!--modal__content-->
  </div><!--modal-->
<script>
  import di from "dependency-injection";
  import base from "../modal-base.riot";
  import rulesTag from '@tags/parts/croco-desk-rules.riot';
  export default {
    components: {
      "modal-base": base,
      "rules-content-tag": rulesTag
    },
    state: {
      isOpen: false,
      isAgreed:false,
    },
    onCheck(e){
      this.state.isAgreed = e.target.checked;
      this.update({ isAgreed: e.target.checked });
    },
    onBeforeMount(){
      this.onOpenModal = () => {
        this.update({ isOpen: true, isAgreed: false });
      };
      this.onCloseModal = () => {
        this.update({ isOpen: false, isAgreed: false });
      };

      this.props.MenuApi.on('agreement:openModal', this.onOpenModal);
      this.props.MenuApi.on('agreement:closeModal', this.onCloseModal);
    },
    onBeforeUnmount() {
      this.props.MenuApi.off('agreement:openModal', this.onOpenModal);
      this.props.MenuApi.off('agreement:closeModal', this.onCloseModal);
      this.onOpenModal = null;
      this.onCloseModal = null;
    }
  };
</script>
</agreement-modal>